export default __webpack_public_path__ + "static/media/seminario2.d93c6717.svg";